import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MinimalLayout } from '../components/templates/MinimalLayout.js';
import { Input } from '../components/atoms/Input.js';
import { Button } from '../components/atoms/Button.js';
import { Typography } from '../components/atoms/Typography.js';
import { Card } from '../components/atoms/Card.js';
import { post, ApiClientError } from '../lib/api-client.js';
import type { ApiResponse } from '../types/api.js';

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await post<ApiResponse<{ user: string }>>('/api/v1/auth/login', { password });
      navigate('/dashboard');
    } catch (err) {
      if (err instanceof ApiClientError) {
        setError(err.message);
      } else {
        setError('ログインに失敗しました。');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <MinimalLayout>
      <Card padding="lg">
        <Typography variant="h3" className="mb-6 text-center">
          {t('login.title')}
        </Typography>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label={t('login.password')}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('login.password_placeholder')}
            required
          />
          {error && (
            <Typography variant="caption" className="block text-center text-red-600">
              {error}
            </Typography>
          )}
          <Button type="submit" size="lg" className="w-full" loading={loading}>
            {t('login.sign_in')}
          </Button>
        </form>
      </Card>
    </MinimalLayout>
  );
}
